import * as React from 'react';
import {useDispatch} from 'react-redux';
import {Switch} from 'react-router-dom';

import {PromptedRoute} from '../../util/prompted-route';

import {fetchSchemaAction} from '../forms/forms-actions';
import {PageWrapper} from '../layout/page-wrapper';
import {fetchDashboardSchema} from '../master-dashboard/actions/base';

import {SchedulerRoutes} from './routes';
import {SchedulerSidebarEmbedded} from './scheduler-sidebar-embedded';

export function SchedulerRootEmbedded() {
    const dispatch = useDispatch();
    // @ts-expect-error
    const fetchFormSchema = () => dispatch(fetchSchemaAction());
    // @ts-expect-error
    const getDashboardSchema = () => dispatch(fetchDashboardSchema());

    React.useEffect(() => {
        fetchFormSchema();
        getDashboardSchema();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PageWrapper sidebar={<SchedulerSidebarEmbedded />} isEmbedded={true}>
            <Switch>
                <SchedulerRoutes />
                <PromptedRoute
                    routeListType='allow'
                    routePaths={
                        // allow all /scheduler based routes
                        ['/scheduler']
                    }
                />
            </Switch>
        </PageWrapper>
    );
}
